var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('Search',{on:{"search":_vm.fetchMovies}}),(this.opened == false)?_c('Movies',{attrs:{"data":_vm.data},on:{"open-movie":_vm.openMovie}}):_c('Movie',{attrs:{"data":_vm.data}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }